import { inject, RendererFactory2 } from '@angular/core';

import { AuthSessionCheckFn } from '../../../common/auth/auth-token/auth-session.guard';

export const AuthSessionCheckOnFocusFn: AuthSessionCheckFn = (checkExpiry) => {
  const rendererFactory = inject(RendererFactory2);
  const renderer = rendererFactory.createRenderer(null, null);

  renderer.listen(window, 'focus', () => {
    checkExpiry();
  });
};
